import axios, { AxiosRequestConfig, AxiosInstance, AxiosResponse } from 'axios';
import * as importUrl from 'url';
import { AuthData } from '../types/AuthData';
import { AuthCredentials } from '../types/AuthCredentials';

/**
 * Podpora přihlašování, ručně psabé api.
 */
export class AuthApi {
  config?: AxiosRequestConfig;
  axiosInstance: AxiosInstance;

  constructor(
    config?: AxiosRequestConfig,
    axiosInstance: AxiosInstance = axios
  ) {
    this.config = config;
    this.axiosInstance = axiosInstance;
  }

  public logout(): Promise<AxiosResponse<void>> {
    return AuthApi.raw.logout(this.config, this.axiosInstance);
  }

  public login(data: AuthCredentials): Promise<AxiosResponse<AuthData>> {
    return AuthApi.raw.login(data, this.config, this.axiosInstance);
  }

  /**
   * @deprecated přes rest nefunguje NTLM autentizace, nutné použít kompletní změnu url např. pomocí window.location, pro načtení url použít metodu ntlmUrl.
   */
  public ntlm(redirect?: string): Promise<AxiosResponse<void>> {
    return AuthApi.raw.ntlm(redirect, this.config, this.axiosInstance);
  }

  public ntlmUrl(redirect?: string): string {
    let uri = `/api/react-auth/ntlm`;

    if (redirect) {
      uri += '?redir=' + encodeURIComponent(redirect);
    }

    return uri;
  }

  public isOpenIdConfigured(): Promise<AxiosResponse<boolean>> {
    return AuthApi.raw.isOpenIdConfigured(this.config, this.axiosInstance);
  }

  public loginByOpenId(): Promise<AxiosResponse<void>> {
    return AuthApi.raw.loginByOpenId(this.config, this.axiosInstance);
  }

  public canUseNtlm(): Promise<AxiosResponse<boolean>> {
    return AuthApi.raw.canUseNtlm(this.config, this.axiosInstance);
  }

  public check(): Promise<AxiosResponse<AuthData>> {
    return AuthApi.raw.check(this.config, this.axiosInstance);
  }

  /** ---------------------------------------------------------- */

  static raw = {
    logout: function(
      config?: AxiosRequestConfig,
      axiosInstance: AxiosInstance = axios
    ): Promise<AxiosResponse<void>> {
      const uri = `/api/react-auth/logout`;

      let finalHeaders = undefined;
      if (config && config.headers) {
        finalHeaders = {
          ...config.headers,
        };
      }

      const finalConfig = {
        ...config,
        headers: finalHeaders,
      };

      return axiosInstance.get<any, AxiosResponse<void>>(uri, finalConfig);
    },
    login: function(
      data: AuthCredentials,
      config?: AxiosRequestConfig,
      axiosInstance: AxiosInstance = axios
    ): Promise<AxiosResponse<AuthData>> {
      const uri = `/api/react-auth/login`;

      let finalHeaders = undefined;
      if (config && config.headers) {
        finalHeaders = {
          ...config.headers,
        };
      }

      const finalConfig = {
        ...config,
        headers: finalHeaders,
      };

      return axiosInstance.post<any, AxiosResponse<AuthData>>(
        uri,
        data,
        finalConfig
      );
    },
    loginByOpenId: function(
      config?: AxiosRequestConfig,
      axiosInstance: AxiosInstance = axios
    ): Promise<AxiosResponse<void>> {
      const uri = `/api/react-auth/loginbyopenid`;

      let finalHeaders = undefined;
      if (config && config.headers) {
        finalHeaders = {
          ...config.headers,
        };
      }

      const finalConfig = {
        ...config,
        headers: finalHeaders,
      };

      return axiosInstance.get<any, AxiosResponse<void>>(uri, finalConfig);
    },
    ntlm: function(
      redirect?: string,
      config?: AxiosRequestConfig,
      axiosInstance: AxiosInstance = axios
    ): Promise<AxiosResponse<void>> {
      const uri = `/api/react-auth/ntlm`;
      const params = { redir: redirect };

      const finalUri = uri + importUrl.format({ query: params });

      let finalHeaders = undefined;
      if (config && config.headers) {
        finalHeaders = {
          ...config.headers,
        };
      }

      const finalConfig = {
        ...config,
        headers: finalHeaders,
      };

      return axiosInstance.get<any, AxiosResponse<void>>(finalUri, finalConfig);
    },
    isOpenIdConfigured: function(
      config?: AxiosRequestConfig,
      axiosInstance: AxiosInstance = axios
    ): Promise<AxiosResponse<boolean>> {
      const uri = `/api/react-auth/isopenidconfigured`;

      let finalHeaders = undefined;
      if (config && config.headers) {
        finalHeaders = {
          ...config.headers,
        };
      }

      const finalConfig = {
        ...config,
        headers: finalHeaders,
      };

      return axiosInstance.get<any, AxiosResponse<boolean>>(uri, finalConfig);
    },
    canUseNtlm: function(
      config?: AxiosRequestConfig,
      axiosInstance: AxiosInstance = axios
    ): Promise<AxiosResponse<boolean>> {
      const uri = `/api/react-auth/canusentlm`;

      let finalHeaders = undefined;
      if (config && config.headers) {
        finalHeaders = {
          ...config.headers,
        };
      }

      const finalConfig = {
        ...config,
        headers: finalHeaders,
      };

      return axiosInstance.get<any, AxiosResponse<boolean>>(uri, finalConfig);
    },
    check: function(
      config?: AxiosRequestConfig,
      axiosInstance: AxiosInstance = axios
    ): Promise<AxiosResponse<AuthData>> {
      const uri = `/api/react-auth/check`;

      let finalHeaders = undefined;
      if (config && config.headers) {
        finalHeaders = {
          ...config.headers,
        };
      }

      const finalConfig = {
        ...config,
        headers: finalHeaders,
      };

      return axiosInstance.get<any, AxiosResponse<AuthData>>(uri, finalConfig);
    },
  };
}
